/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelFreightMatchingProfileLookup.ts  *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/powerbroker/freight-matching-profile-lookup";

export class AutogenModelFreightMatchingProfileLookup<RowType extends ModelRow> extends Endpoint<RowType, RowFreightMatchingProfileLookupFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowFreightMatchingProfileLookup extends ModelRow<RowFreightMatchingProfileLookupFields> {
	constructor(values?: Partial<RowFreightMatchingProfileLookupFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowFreightMatchingProfileLookupFields {
	add_available_tractors: string;
	assign_enabled_users: string;
	assign_notify_emails: string;
	assign_notify_enabled: string;
	assign_notify_users: string;
	assigned_booking_users: string;
	auto_dispatch: string;
	auto_rate_confirm_template: number;
	brk_qual_prof_override: string;
	brokerage_code: string;
	brokerage_status_filter: string;
	can_retrieve_offer_status: string;
	can_send_equip_prefs: string;
	can_send_lane_prefs: string;
	cancel_available_tractors: string;
	carrier_offer_filter: string;
	carrier_qual_status: string;
	carrier_return_limit: number;
	carrier_status: string;
	clear_pay_info: string;
	comment_type: string;
	company_id: string;
	create_available_tractors: string;
	create_callin: string;
	create_mc_position: string;
	create_order_hist_comment: string;
	customer_filter: string;
	days_after: number;
	days_prior: number;
	descr: string;
	enable_booking_email: string;
	enable_carrier_driver: string;
	enable_carrier_equipment: string;
	enable_carrier_offer: string;
	enable_comment: string;
	enable_load_booking: string;
	enable_milestones: string;
	enable_responsibility: string;
	enable_settlement_status: string;
	enable_unassignment_email: string;
	enabled_carrier_unassign: string;
	exclude_customer_filter: string;
	exclude_locked_movements: string;
	exclude_order_type: string;
	exclude_orders_on_hold: string;
	exclude_revcode_filter: string;
	exclude_status_filter: string;
	id: string;
	include_prohibited: string;
	included_contacts: string;
	included_loadboard_value: string;
	is_pay_rate_provider: string;
	last_process_datetime: Date;
	load_return_limit: number;
	milestone_users: string;
	movement_status: string;
	notify_arc_failure: string;
	notify_booking_carrier: string;
	notify_booking_dispatcher: string;
	notify_booking_entered: string;
	notify_booking_groups: string;
	notify_booking_operations: string;
	notify_booking_rev_code: string;
	notify_booking_sales: string;
	notify_booking_users: string;
	notify_on_book_failure: string;
	notify_on_offer_failure: string;
	offer_allowed_users: string;
	offer_carrier_warning: string;
	offer_fail_reasons: string;
	offer_max_pay_override: string;
	offer_notify_carrier: string;
	offer_notify_dispatcher: string;
	offer_notify_emails: string;
	offer_notify_enabled: string;
	offer_notify_entered: string;
	offer_notify_groups: string;
	offer_notify_operations: string;
	offer_notify_rev_code: string;
	offer_notify_sales: string;
	offer_notify_users: string;
	order_mode_filter: string;
	order_type_filter: string;
	other_booking_emails: string;
	override_pay_amt: string;
	pay_rate_provider_users: string;
	posted_type: string;
	process_interval: number;
	rate_confirmation_from: string;
	receive_cc_arc: string;
	record_return_limit: number;
	retrieve_available_tractors: string;
	revcode_filter: string;
	send_arc: string;
	tractor_brokerage_code: string;
	update_scheduled_call_time: string;
	use_dfm_eta: string;
}

